export default class Benefiting {
  constructor ({ id = null, name = null, page_id = null, page_slug = null } = {}) {
    this.id = id
    this.name = name
    this.page_id = page_id
    this.page_slug = page_slug
  }
}
